/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PasswordPolicyResponse } from '../models/PasswordPolicyResponse';
import type { UserEnrolledFactorsResponse } from '../models/UserEnrolledFactorsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FactorsService {
    /**
     * Get user's enrolled factors
     * Get all authentication factors enrolled by the current user
     * @param userSession
     * @returns UserEnrolledFactorsResponse Successful Response
     * @throws ApiError
     */
    public static getEnrolledFactors(
        userSession?: (string | null),
    ): CancelablePromise<UserEnrolledFactorsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/enrolled-factors',
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get password policy
     * Get the password validation rules for client-side validation hints
     * @param userSession
     * @returns PasswordPolicyResponse Successful Response
     * @throws ApiError
     */
    public static getPasswordPolicy(
        userSession?: (string | null),
    ): CancelablePromise<PasswordPolicyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/password-policy',
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
